/**
 * Add interest view — UI only; state from useAddInterestViewModel.
 */

import { ArrowLeft } from 'lucide-react'
import { LoadingSpinner } from '@/features/common/components/LoadingSpinner'
import { useAddInterestViewModel } from '../viewmodels/use_add_interest_viewmodel'

export function AddInterestPageView() {
  const { fileInputRef, form, actions } = useAddInterestViewModel()
  const { interestName, isActive, fileName, errors, isSubmitting } = form

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <button
          onClick={actions.cancel}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <ArrowLeft className="w-5 h-5 text-gray-600" />
        </button>
        <div>
          <h1 className="text-2xl font-semibold text-gray-800">Add Interest</h1>
        </div>
      </div>

      {/* Form */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <form
          onSubmit={e => {
            e.preventDefault()
            void actions.submit()
          }}
          className="space-y-6"
        >
          {/* Interest Name */}
          <div>
            <label htmlFor="interestName" className="block text-sm font-medium text-gray-700 mb-2">
              Interest Name<span className="text-red-500">*</span>
            </label>
            <input
              id="interestName"
              type="text"
              value={interestName}
              onChange={e => {
                actions.setInterestName(e.target.value)
                actions.clearFieldError('name')
              }}
              placeholder="Enter Interest Name"
              className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 ${
                errors.name ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.name && <p className="mt-1 text-sm text-red-600">{errors.name}</p>}
          </div>

          {/* Icon */}
          <div>
            <label htmlFor="icon" className="block text-sm font-medium text-gray-700 mb-2">
              Icon
            </label>
            <div className="flex items-center gap-4">
              <input
                ref={fileInputRef}
                id="icon"
                type="file"
                accept="image/*"
                onChange={e => actions.handleFileChange(e.target.files?.[0])}
                className="hidden"
              />
              <button
                type="button"
                onClick={actions.openFilePicker}
                className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Choose File
              </button>
              <span className="text-sm text-gray-500">{fileName}</span>
            </div>
            {errors.icon && <p className="mt-1 text-sm text-red-600">{errors.icon}</p>}
          </div>

          {/* Active Checkbox */}
          <div>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={isActive}
                onChange={e => actions.setIsActive(e.target.checked)}
                className="w-4 h-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
              />
              <span className="text-sm font-medium text-gray-700">Active</span>
            </label>
          </div>

          {/* Action Buttons */}
          <div className="flex items-center justify-end gap-4 pt-4 border-t border-gray-200">
            <button
              type="button"
              onClick={actions.cancel}
              className="px-6 py-2 text-sm font-medium bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-6 py-2 text-sm font-medium text-white rounded-md hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
              style={{ backgroundColor: '#019b9a' }}
            >
              {isSubmitting ? (
                <span className="flex items-center gap-2">
                  <LoadingSpinner size="sm" />
                  Saving...
                </span>
              ) : (
                'Save'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

